module.exports = __webpack_public_path__ + "static/media/jenny-sommerfeld.44e96b26.jpg";